import axiosInstance from "../api/axiosInstance";

const categoryService = new (class CategoryService {
  async getMainCategories() {
    const response = await axiosInstance.get("/categories/main");
    return response.data;
  }

  async getSubCategories(parentId) {
    const response = await axiosInstance.get(`/categories/${parentId}`);
    return response.data;
  }

  async getAllCategories() {
    const response = await axiosInstance.get("/categories/public/list");
    return response.data;
  }
})();

export default categoryService; 